import { PropsWithTestId, UploadedImage } from '../../../../../../../types';
import { useGetImgixImageUrl } from '../../../../../../../hooks';
import styles from './RightImage.module.scss';

export interface RightImageProps {
  image: UploadedImage;
}

export function RightImage(props: PropsWithTestId<RightImageProps>) {
  const { image, testId } = props;
  const backgroundImage = useGetImgixImageUrl(image?.path);

  return (
    <div className={styles.wrapper} data-testid={testId}>
      {backgroundImage && (
        <img src={backgroundImage} alt="hero" className={styles.image} />
      )}
    </div>
  );
}

RightImage.defaultProps = {
  testId: 'hub-hero-module-right-image',
};
